<ng-container *transloco="let t">
  <div class="mb-2 text-sm font-medium text-surface-600 dark:text-surface-300" aria-live="polite" role="status">
    {{ t("app.fileUpload.selectedFilesCount", { count: selectedFileCount }) }}
  </div>

  <p-fileUpload
    #fileUpload
    mode="advanced"
    [name]="name"
    [accept]="fileTypes"
    [maxFileSize]="maxFileSize"
    [auto]="false"
    [showUploadButton]="false"
    [showCancelButton]="false"
    [chooseLabel]="chooseButtonLabel"
    [class.ng-invalid]="isInvalid"
    [class.ng-dirty]="isDirty"
    (onSelect)="onSelect($event)"
    (onRemove)="onRemove($event)"
    [disabled]="disabled"
    [ngClass]="{ 'p-disabled': disabled }"
    [multiple]="true"
    [invalidFileSizeMessageSummary]="t('app.fileUpload.invalidSizeSummary')"
    [invalidFileSizeMessageDetail]="t('app.fileUpload.invalidSizeDetail')"
    [invalidFileTypeMessageSummary]="t('app.fileUpload.invalidTypeSummary')"
    [invalidFileTypeMessageDetail]="t('app.fileUpload.invalidTypeDetail')"
  >
    <ng-template pTemplate="empty">
      <button
        type="button"
        class="flex flex-col items-center justify-center p-2 cursor-pointer hover:bg-surface-100 dark:hover:bg-surface-800"
        (click)="fileUpload.choose()"
      >
        <i class="pi pi-cloud-upload text-2xl text-surface-400 mb-2"></i>
        <span class="text-md text-surface-600 dark:text-surface-300">{{ t("app.fileUpload.dragAndDropHint") }}</span>

        @if (fileTypes) {
          <div class="text-xs text-surface-500 dark:text-surface-400 mt-1">
            {{ t("app.fileUpload.allowedTypes", { allowedFileTypes: fileTypes }) }}
          </div>
        }
      </button>
    </ng-template>

    <!-- Custom item template for file previews -->
    <ng-template let-file pTemplate="file">
      <div class="flex items-center p-3 border-b border-surface-200 dark:border-surface-700 last:border-b-0">
        <div class="mr-4">
          <!-- Show thumbnail for images -->
          @if (file.type.startsWith("image/")) {
            <img [src]="file.objectURL" [alt]="file.name" class="w-15 h-15 object-cover rounded-md" />
          }
          <!-- Show appropriate file icon for non-images -->
          @else {
            <div class="flex items-center justify-center w-15 h-15">
              <i [ngClass]="[getFileIcon(file), 'text-4xl', 'text-surface-600', 'dark:text-surface-300']"></i>
            </div>
          }
        </div>
        <div class="flex-grow min-w-0">
          <div class="text-md">{{ file.name }}</div>
          <div class="text-xs text-surface-500 dark:text-surface-400">{{ file.size | fileSize }}</div>
        </div>
        <button
          type="button"
          class="flex items-center justify-center w-8 h-8 rounded-full hover:bg-surface-100 dark:hover:bg-surface-700 transition-colors"
          (click)="removeFile(file)"
          [attr.aria-label]="t('app.fileUpload.removeFile')"
        >
          <i class="pi pi-times text-red-500 dark:text-red-400"></i>
        </button>
      </div>
    </ng-template>
  </p-fileUpload>
</ng-container>
